import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BarChart3, Building2, Calendar, ChevronDown, ClipboardList, Flame, MessageCircle, Quote, Users } from 'lucide-react';
type ProgramPreview = {
  eyebrow: string;
  title: string;
  time: string;
  note?: string;
};
type Testimonial = {
  quote: string;
  name: string;
  role: string;
};
const PROGRAMS: ProgramPreview[] = [{
  eyebrow: 'Homeschool Athletes',
  title: 'Homeschool Multisport',
  time: 'Tue and Thu · 2:30 to 4:00 PM',
  note: 'Founding rate $325 through Aug 9, then $400'
}, {
  eyebrow: 'Middle School · Ages 11 to 13',
  title: 'Performance Prep',
  time: 'Tue and Thu · 4:45 to 5:45 PM'
}, {
  eyebrow: 'High School · Ages 14+',
  title: 'Advanced Court',
  time: 'Tue and Thu · 5:45 to 7:00 PM'
}, {
  eyebrow: 'High School · Ages 14+',
  title: 'Advanced Field',
  time: 'Tue and Thu · 7:00 to 8:15 PM'
}];
const TESTIMONIALS: Testimonial[] = [{
  quote: 'Reach is the first place that actually treats my 7th grader like an athlete, not a kid. He looks forward to training and asks about his test numbers all the time.',
  name: 'Daniel R.',
  role: 'Parent · MS Basketball · Frisco'
}, {
  quote: 'My son added 4 inches to his vertical and cut his 40 time in one summer. The testing every month shows him the work is paying off, and he wants to be in the gym.',
  name: 'Marcus T.',
  role: 'Parent · Varsity Football · Prosper HS'
}];
const FAQS = [{
  question: 'What if my athlete has never trained before?',
  answer: 'Foundations and Performance Prep are built for first-time athletes. Every program starts with mechanics before adding load.'
}, {
  question: 'What if my athlete misses a session?',
  answer: 'Every monthly enrollment includes one free make-up per month in any age-appropriate class, subject to availability.'
}, {
  question: 'Do you offer a sibling discount?',
  answer: 'Additional siblings receive 10% off their monthly plan, applied at checkout.'
}];
export function Home() {
  return <div className="w-full bg-white" data-id="element-547" data-mp="1ojzfsgzuc68g">
      <Hero data-id="element-548" data-mp="1anciue7w1g2j" />
      <ServiceAreaStrip data-id="element-549" data-mp="1ankvc503mjd7" />
      <ProgramsPreview data-id="element-550" data-mp="1aodvgn4jyamd" />
      <WhyReach data-id="element-551" data-mp="1aovwry62nf15" />
      <Testimonials data-id="element-552" data-mp="1fldz6rdxj1ab" />
      <HowItWorks data-id="element-553" data-mp="1fmp4ivn0wh3j" />
      <FAQPreview data-id="element-554" data-mp="1fm5xi9ywvd4a" />
      <FinalCta data-id="element-555" data-mp="1fnqh54jotbnd" />
    </div>;
}
function Hero() {
  return <section className="relative flex min-h-[640px] h-screen w-full items-center justify-center overflow-hidden bg-reach-black" data-id="element-556" data-mp="23c9pfk2qlofg">
      <div className="absolute inset-0" data-id="element-557" data-mp="289i6tig29ofn">
        <img src="https://cdn.magicpatterns.com/uploads/rgLqfeYbfsME5fh7JYem7K/_DSC2694_2.jpg" alt="Reach Performance athletes training on the field" className="h-full w-full object-cover object-center photo-editorial" style={{
        filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
      }} data-id="element-558" data-mp="1tlx6txehg5by" />
        <div className="absolute inset-0 bg-black/70" data-id="element-559" data-mp="2r1ksx9bh1wxa" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-560" data-mp="flkapc7z5raj" />
      </div>

      <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-561" data-mp="amz6z2tikphc">
        <div className="absolute top-1/3 -left-40 h-2 w-[60%] -rotate-[8deg] bg-reach-red opacity-60" data-id="element-562" data-mp="akwjoqjqxagb" />
        <div className="absolute top-[42%] -left-40 h-2 w-[45%] -rotate-[8deg] bg-reach-red opacity-40" data-id="element-563" data-mp="kcitqjkcl3hh" />
        <div className="absolute top-[50%] -left-40 h-2 w-[30%] -rotate-[8deg] bg-reach-red opacity-30" data-id="element-564" data-mp="3ssc74pjdtyub" />
      </div>

      <div className="relative z-10 mx-auto max-w-container px-4 text-center md:px-8" data-id="element-565" data-mp="3ntskso0vml1f">
        <p className="mb-5 font-inter text-sm font-semibold uppercase tracking-[0.25em] text-reach-red md:text-base" data-id="element-566" data-mp="5necp5pah5ay">
          Fall Season · August 11 to December 17
        </p>
        <h1 className="mb-5 font-bebas text-[56px] leading-[0.9] tracking-wide text-white sm:text-7xl md:text-8xl lg:text-[96px]" data-id="element-567" data-mp="qw8c6xvf8z5">
          Train With Us
        </h1>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-base text-white md:text-xl" data-id="element-568" data-mp="1c36rrmqq5sqx">
          Speed, strength, and athletic development in McKinney, TX.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-569" data-mp="2cc6jh94m0vo8">
          <Link to="/pricing" className="btn-primary sm:w-auto" data-id="element-570" data-mp="2harjb7fy9dc5">
            Enroll Now
          </Link>
          <Link to="/fall-2026" className="btn-secondary-dark sm:w-auto" data-id="element-571" data-mp="2m92rldqljfs9">
            See Fall Schedule
          </Link>
        </div>
      </div>
    </section>;
}
function ServiceAreaStrip() {
  return <section className="bg-reach-red" data-id="element-572" data-mp="2v9r587c2ve4m">
      <p className="px-4 py-3 text-center font-inter text-[10px] font-semibold uppercase tracking-[0.24em] text-white sm:text-xs" data-id="element-573" data-mp="3020v5nd70e6w">
        Training athletes from McKinney · Frisco · Allen · Prosper · Plano
      </p>
    </section>;
}
function ProgramsPreview() {
  return <section className="bg-white py-20 md:py-28" data-id="element-574" data-mp="3e2bl8o6ohor0">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-575" data-mp="3e34vw08rcyef">
        <div className="mb-12 text-center" data-id="element-576" data-mp="12fhsz136b35f">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-577" data-mp="12gjgi51dli41">
            Fall 2026 Programs
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-578" data-mp="te1wzyd3v3kq">
            Find Your Group
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-inter text-base text-reach-black/70 md:text-lg" data-id="element-579" data-mp="og0cra3y0y7o">
            Four groups train Tuesday and Thursday. Review the full schedule before choosing a plan.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-580" data-mp="1h4e9znn7jqi6">
          {PROGRAMS.map(program => <article key={program.title} className="flex min-h-[250px] flex-col border-b-4 border-transparent bg-reach-black p-6 text-white transition-colors duration-200 hover:border-reach-red" data-id="element-581" data-mp="1cb33xoq7zdrb">
              <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.22em] text-reach-red" data-id="element-582" data-mp="2028fhrp4njvt">
                {program.eyebrow}
              </p>
              <h3 className="mb-5 font-bebas text-3xl leading-none tracking-wide" data-id="element-583" data-mp="3ucyfufe3huhc">
                {program.title}
              </h3>
              <p className="font-inter text-base leading-relaxed text-white/85" data-id="element-584" data-mp="3klavszjvbfpw">
                {program.time}
              </p>
              {program.note && <p className="mt-auto pt-6 font-inter text-sm font-semibold leading-relaxed text-white" data-id="element-585" data-mp="3phj3xszne8nk">
                  {program.note}
                </p>}
            </article>)}
        </div>

        <div className="mt-10 text-center" data-id="element-586" data-mp="31m6mrqsbtly8">
          <Link to="/fall-2026" className="btn-secondary" data-id="element-587" data-mp="31n88qqavrsuq">
            See Fall Schedule <ArrowRight size={16} className="ml-2" data-id="element-588" data-mp="36k89cloyo3eg" />
          </Link>
        </div>
      </div>
    </section>;
}
function WhyReach() {
  const pillars = [{
    Icon: Calendar,
    title: 'Periodized Programming',
    body: 'Every day has a purpose. No random workouts.'
  }, {
    Icon: BarChart3,
    title: 'Testing Every 4 Weeks',
    body: 'Progress is tracked on the same markers.'
  }, {
    Icon: Users,
    title: 'Small Groups',
    body: 'Max 8 athletes per session.'
  }, {
    Icon: Building2,
    title: 'Built To Train',
    body: 'Speed gates, indoor turf, and recovery space.'
  }];
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-589" data-mp="1xo2yc4venr6x">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-590" data-mp="1xmi30d19o480">
        <div className="mb-14 text-center" data-id="element-591" data-mp="1sphyi6k2f9j0">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-592" data-mp="1soqe7rvx4y81">
            What Makes Us Different
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-5xl" data-id="element-593" data-mp="22mmjw46370yr">Why Reach</h2>
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10" data-id="element-594" data-mp="ca6zva6mt2bi">
          {pillars.map(({
          Icon,
          title,
          body
        }) => <article key={title} className="text-center" data-id="element-595" data-mp="8ay2lvcdumb7">
              <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-[4px] bg-reach-black" data-id="element-596" data-mp="wuuyhxmbiduz">
                <Icon size={28} className="text-reach-red" aria-hidden="true" data-id="element-597" data-mp="11rv64cytfoo7" />
              </div>
              <h3 className="mb-3 font-bebas text-2xl tracking-wide" data-id="element-598" data-mp="16l64dppkax4i">{title}</h3>
              <p className="font-inter text-base leading-relaxed text-reach-black/80" data-id="element-599" data-mp="1alq2avhym4rp">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}
function Testimonials() {
  return <section className="relative overflow-hidden bg-reach-black py-20 md:py-28" data-id="element-600" data-mp="ivbrj858t8k9">
      <div className="absolute top-0 -left-20 h-1 w-[40%] rotate-[3deg] bg-reach-red opacity-50" data-id="element-601" data-mp="mvdt7haza1zj" />
      <div className="absolute bottom-0 -right-20 h-1 w-[40%] rotate-[3deg] bg-reach-red opacity-50" data-id="element-602" data-mp="rvi4msx146iw" />
      <div className="relative mx-auto max-w-container px-4 md:px-8" data-id="element-603" data-mp="1ybu3yxbl7ug2">
        <div className="mb-12 text-center" data-id="element-604" data-mp="23a5bh1eetsv4">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-605" data-mp="238uaf9ccmz7p">
            From The Families We Train
          </p>
          <h2 className="font-bebas text-4xl leading-none tracking-wide text-white md:text-6xl" data-id="element-606" data-mp="28f961ego2ayg">
            Real Athletes. Real Results.
          </h2>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-607" data-mp="23mfykittcoio">
          {TESTIMONIALS.map(testimonial => <article key={testimonial.name} className="flex flex-col border border-white/10 bg-white/[0.04] p-7 md:p-9" data-id="element-608" data-mp="1unb4bopabhcb">
              <Quote size={32} className="mb-4 shrink-0 text-reach-red" aria-hidden="true" data-id="element-609" data-mp="1pn6mnvcn4gki" />
              <p className="mb-7 font-inter text-base leading-relaxed text-white md:text-lg" data-id="element-610" data-mp="1kpwwgdhfg0vm">
                &quot;{testimonial.quote}&quot;
              </p>
              <div className="mt-auto border-t border-white/10 pt-5" data-id="element-611" data-mp="3f3pjzawi5qmm">
                <p className="mb-1 font-bebas text-lg leading-none tracking-wider text-white" data-id="element-612" data-mp="3b1ujg8mebh9w">
                  {testimonial.name}
                </p>
                <p className="font-inter text-xs uppercase tracking-[0.2em] text-white/60" data-id="element-613" data-mp="cna3eispe1op">
                  {testimonial.role}
                </p>
              </div>
            </article>)}
        </div>
        <p className="mt-8 text-center font-inter text-xs leading-relaxed text-white/50" data-id="element-614" data-mp="mlzoekfwc296">
          Results vary by athlete, starting point, and adherence.
        </p>
      </div>
    </section>;
}
function HowItWorks() {
  const steps = [{
    number: '01',
    Icon: ClipboardList,
    title: 'Review The Schedule',
    body: 'Choose the fall group that fits your athlete.'
  }, {
    number: '02',
    Icon: MessageCircle,
    title: 'Choose A Plan',
    body: 'Compare monthly, private, and drop-in options.'
  }, {
    number: '03',
    Icon: Flame,
    title: 'Start Training August 11',
    body: 'Fall groups meet Tuesday and Thursday.'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-615" data-mp="32bsvqo8p1ehk">
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-616" data-mp="1hvme56xmkbcz">
        <div className="mb-14 text-center" data-id="element-617" data-mp="1hu1o9um99glg">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-618" data-mp="1mnml3jc444j2">
            How It Works
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-619" data-mp="18td6cotqqw3a">Get Started In 3 Steps</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8" data-id="element-620" data-mp="20mcil02ug67y">
          {steps.map(({
          number,
          Icon,
          title,
          body
        }) => <article key={number} className="border-b-4 border-transparent bg-reach-gray p-7 md:p-8" data-id="element-621" data-mp="25lp33e68t17d">
              <div className="mb-5 flex items-center gap-4" data-id="element-622" data-mp="1rkmi74qzhwy1">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[4px] bg-reach-black" data-id="element-623" data-mp="1wkqyourw6ro9">
                  <Icon size={22} className="text-reach-red" aria-hidden="true" data-id="element-624" data-mp="g5zj5ifuhewd" />
                </div>
                <span className="font-bebas text-4xl leading-none tracking-wide text-reach-red" data-id="element-625" data-mp="l653senp614y">{number}</span>
              </div>
              <h3 className="mb-3 font-bebas text-3xl leading-tight tracking-wide" data-id="element-626" data-mp="2mtge1quurb14">{title}</h3>
              <p className="font-inter text-base leading-relaxed text-reach-black/80" data-id="element-627" data-mp="2hwzm0lkj8cir">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}
function FAQPreview() {
  const [openQuestion, setOpenQuestion] = useState<number | null>(0);
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-628" data-mp="244jrya9lzotz">
      <div className="mx-auto max-w-3xl px-4 md:px-8" data-id="element-629" data-mp="241x93eh9pmwg">
        <div className="mb-12 text-center" data-id="element-630" data-mp="1z45gei8stwr7">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-631" data-mp="1z7jma0go8o3e">
            Parents Ask
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-5xl" data-id="element-632" data-mp="1q5a912u0qgmb">Common Questions</h2>
        </div>
        <div className="space-y-2" data-id="element-633" data-mp="3oj3n2j9gw80q">
          {FAQS.map((faq, index) => {
          const isOpen = openQuestion === index;
          return <article key={faq.question} className="overflow-hidden border-b-4 border-transparent bg-white" data-id="element-634" data-mp="3kgp5e2hjbeb1" data-mpi={index}>
                <button type="button" onClick={() => setOpenQuestion(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-black/[0.02] md:px-6 md:py-5" aria-expanded={isOpen} data-id="element-635" data-mp="1b9vc37nq7xe7">
                  <span className="font-inter text-base font-semibold text-reach-black md:text-lg" data-id="element-636" data-mp="nd7unfm64l2i">
                    {faq.question}
                  </span>
                  <ChevronDown size={20} className={`shrink-0 text-reach-red transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-637" data-mp="wcumb9p3icid" />
                </button>
                {isOpen && <p className="border-t border-black/5 px-5 pb-5 pt-4 font-inter text-base leading-relaxed text-reach-black/80 md:px-6 md:pb-6" data-id="element-638" data-mp="2cqkr6io1h4t2">
                    {faq.answer}
                  </p>}
              </article>;
        })}
        </div>
        <div className="mt-10 text-center" data-id="element-639" data-mp="26cow2gchccoz">
          <Link to="/fall-2026" className="btn-secondary" data-id="element-640" data-mp="2kalwjnu2138x">
            See Fall Schedule <ArrowRight size={16} className="ml-2" data-id="element-641" data-mp="2g90bhf7d9inn" />
          </Link>
        </div>
      </div>
    </section>;
}
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-642" data-mp="2u6ypgjhrzd2m">
      <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-643" data-mp="2p9q306plgmvk">
        <h2 className="mb-4 font-bebas text-5xl tracking-wide text-white md:text-7xl" data-id="element-644" data-mp="2p7m3e0yqaa13">Ready To Start</h2>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-lg text-white md:text-xl" data-id="element-645" data-mp="3405v85gfgv38">
          Choose a fall plan or talk through your athlete&apos;s next step.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-646" data-mp="3czap2yh1o092">
          <Link to="/pricing" className="inline-flex min-h-[44px] items-center justify-center rounded-[4px] bg-white px-6 font-inter text-sm font-semibold uppercase tracking-wide text-reach-black transition-all duration-200 ease-out hover:-translate-y-[3px] hover:bg-reach-black hover:text-white md:min-h-[48px] md:text-base" data-id="element-647" data-mp="3rlzo6z7dwbex">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-648" data-mp="38vi7xu3qn8ag">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}